import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ContextProviderService {

  public countryCode$ = new BehaviorSubject<string>(null);

  constructor(@Inject(PLATFORM_ID) public platformId: Object) {
  }
}
